module.exports = __webpack_public_path__ + "img/org-review-avg.fd150bcd.svg";